import React from "react";

//interfaces
import { IBasicEmailInput } from "../../../interfaces/textInputs/IBasicTextInput";
import BasicButton from "../buttons/BasicButton";



const BasicEmailInput = ({id, className, labelText, labelIsHidden, placeholderText, textString, setTextString, maxLength, isDisabled, isReadOnly, buttonContent, onButtonClick}: IBasicEmailInput) => {
    
    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const isButtonDisabled = !textString || !isValidEmail(textString);

    return (
        <div className={`basic-email-input-wrapper ${className ?? ""} `}>
            <label htmlFor={`basic-email-input-${id || ''}`} className={`${labelIsHidden ? "sr-only" : ""} basic-email-input-label`}>
                {labelText}
            </label>
         
            <input
                key={id ? `basic-email-input-${id}`: ''}
                type={"email"}
                id={`basic-email-input-${id || ''}`}
                className={"basic-text-input"}
                placeholder={placeholderText}
                value={textString}
                onChange={(e) => setTextString(e.target.value)}
                aria-label="Add your Text"
                maxLength={maxLength}
                disabled={isDisabled}
                readOnly={isReadOnly}
            />

            {buttonContent &&
                <BasicButton 
                    isDisabled={isButtonDisabled || isDisabled} 
                    onButtonClick={onButtonClick} 
                    content={buttonContent} 
                    ariaLabel={"Save Email"} 
                    className="basic-email-button"
                />
            }
        </div>
    );
};

export default BasicEmailInput